import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Kpi } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Kpi.Basic>> =>
	Http.get(`${baseUrl}/by-location`, { params })

export const retrieveKpiOptionsByLocation = (
	serviceSiteId: Key
): Promise<Kpi.OptionsByserviceSiteId> =>
	Http.get(`${baseUrl}/with-categories`, { params: { serviceSiteId } })

export const addKpi = (payload: Omit<Kpi.Request.Add, 'rowKey'>): Promise<Kpi.MeasureResponse> =>
	Http.post(`${baseUrl}/measures`, payload)

export const retrieveKpiMeasureData = (
	payload: Kpi.MeasureRequest
): Promise<Kpi.KpiLocationMeasure[]> => {
	const { kpiId, serviceSiteId, ...params } = payload
	return Http.get(`${baseUrl}/${kpiId}/locations/${serviceSiteId}/measures`, {
		params
	})
}

export const editKpi = (
	payload: Kpi.Request.Edit,
	kpiId: number,
	measureId: number
): Promise<void> => Http.put(`${baseUrl}/${kpiId}/measures/${measureId}`, payload)

export const getKpiById = (id: Key): Promise<Kpi.Basic> => Http.get(`${baseUrl}/${id}`)

export const retrieveMetricFilterOptions = (): Promise<Kpi.Metric.FilterOptions[]> =>
	Http.get(`${baseUrl}/with-categories`)

export const retrieveMetricYears = (id: Key): Promise<Kpi.Metric.FilterOptions> =>
	Http.get(`${baseUrl}/${id}/years/options`)
